<div>
  <nav class="navbar sticky-top navbar-light bg-white">
    <div class="container-fluid">
      <div class="site-logo">
        <a class="navbar-brand" routerLink="accueil" routerLinkActive="active">
          <div class="logo-image">
                <img src="../../assets/images/logocie-mon-toit-short.png" class="logo-image" alt="mon-toit"> 
          </div>
        </a>
      </div>
      <div class="navbar-item d-lg-block " >
        <a href="/connexion" class="btn btn-success w-100" role="button" routerLink="connexion" *ngIf="!isLoggedIn">Connexion</a>
        <!-- START:: user-menu -->
        <div class="navbar-user-menu d-flex" *ngIf="isLoggedIn">
          
          <div class="container d-flex flex-wrap align-items-end justify-content-end justify-content-lg-end">
              <div class="dropdown text-end">
               
                  <a class="dropdown-item" routerLink="usager/{{this.accoundId}}/editer" routerLinkActive="active"  data-bs-toggle="tooltip" data-bs-placement="left" title="Compte usager" ><i class="bi bi-person-circle"></i></a>
                
              </div>
              <div class="user-logedin">
                <div class="user-fullname">
                 Bonjour! {{this.first_name}} {{this.last_name}}
                </div>
                {{this.username}}
              </div>
          </div>
        </div>
        <!-- END:: user-menu -->
      </div>
    </div>
  </nav>
  <nav class="row d-lg-none top-tabs-menu bg-grey text-white">
    <nav *ngIf="isLoggedIn && !isForeman">
      <ul class="nav nav-tabs text-white">
        <li class="nav-item">
          <a routerLink="clients" routerLinkActive="active" class="nav-link"><div class="menu-item">Clients</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="soumissions" routerLinkActive="active" class="nav-link"><div class="menu-item">Soumissions</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="contrats" routerLinkActive="active" class="nav-link"><div class="menu-item">Contrats</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="factures" routerLinkActive="active" class="nav-link"><div class="menu-item">Factures</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="commandes" routerLinkActive="active" class="nav-link"><div class="menu-item">Bons de Commande</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="calendrier" routerLinkActive="active" class="nav-link"><div class="menu-item">Cal. Vendeurs</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="calendrier-jobs" routerLinkActive="active" class="nav-link"><div class="menu-item">Cal. Jobs</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="calendrier-suivis" routerLinkActive="active" class="nav-link"><div class="menu-item">Cal. Suivis</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="gestion" routerLinkActive="active" class="nav-link"><div class="menu-item">Gestion</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="chantier" routerLinkActive="active" class="nav-link"><div class="menu-item">Chantier</div></a>
        </li>
      </ul>
    </nav>
  </nav>
 <!-- <aside class="d-flex flex-column flex-shrink-0 col-1 sticky-left text-white bg-grey d-none d-lg-block">--> 
  <nav class="d-flex flex-row top-main-menu flex-shrink-0 col-12 sticky-top text-white bg-grey d-none d-lg-block">
    <nav *ngIf="isLoggedIn && !isForeman">
      <ul class="nav nav-pills flex-row mr-auto">
        <li class="nav-item">
          <a routerLink="clients" routerLinkActive="active" class="nav-link text-white"><i class="bi bi-people"></i><div class="menu-item">Clients</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="soumissions" routerLinkActive="active" class="nav-link text-white"><i class="bi bi-list-ul"></i><div class="menu-item">Soumissions</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="contrats" routerLinkActive="active" class="nav-link text-white"><i class="bi bi-card-list"></i><div class="menu-item">Contrats</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="factures" routerLinkActive="active" class="nav-link text-white"><i class="bi bi-cash-coin"></i><div class="menu-item">Factures</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="commandes" routerLinkActive="active" class="nav-link text-white"><i class="bi bi-cart-check"></i><div class="menu-item">Bons de Commande</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="calendrier" routerLinkActive="active" class="nav-link text-white"><i class="bi bi-calendar"></i><div class="menu-item">Calendrier Vendeurs</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="calendrier-jobs" routerLinkActive="active" class="nav-link text-white"><i class="bi bi-calendar3"></i><div class="menu-item">Calendrier Jobs</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="calendrier-suivis" routerLinkActive="active" class="nav-link text-white"><i class="bi bi-calendar-check"></i><div class="menu-item">Calendrier Suivis</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="gestion" routerLinkActive="active" class="nav-link text-white"><i class="bi bi-gear"></i><div class="menu-item">Gestion</div></a>
        </li>
        <li class="nav-item">
          <a routerLink="chantier" routerLinkActive="active" class="nav-link text-white"><i class="bi bi-hammer"></i><div class="menu-item">Chantier</div></a>
        </li>
      </ul>
    </nav>
    <!--FM-->
    <nav *ngIf="isLoggedIn && isForeman">
      <ul class="nav nav-pills flex-row mr-auto">
        <li class="nav-item">
          <a routerLink="chantier" routerLinkActive="active" class="nav-link text-white"><i class="bi bi-hammer"></i><div class="menu-item">Chantier</div></a>
        </li>
      </ul>
    </nav>
  </nav>
  <div class="d-flex">
    

    <main id="app" class="row">
      <div class="container">
        <div class="row">
          <router-outlet></router-outlet>
        </div>
      </div>
    </main>
  </div>
</div>